import { css } from 'styled-components';

export const innerBorder = style => css`
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: inherit;
    border: ${style || 'none'};
    pointer-events: none;
    user-select: none;
  }
`;
